import GoBackButton from '@/common/components/GoBackButton'
import { MaintenanceForwardingsDirectiveFormProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { InfoIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

const CreateForwardingDirectiveData = ({ directiveDetails }: MaintenanceForwardingsDirectiveFormProps) => {
  const { id: workflowId } = useParams()

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <GoBackButton
          fallback={`/maintenance-workflows/${workflowId}/forwardings/create`}
          searchLastRouteFromFallback
        />

        <p className="text-lg font-bold">{directiveDetails.name}</p>

        {directiveDetails.description && (
          <>
            <InfoIcon
              className="size-4 text-white-400 cursor-help"
              data-tooltip-id="directive-description-tooltip"
            />

            <Tooltip
              id="directive-description-tooltip"
              place="bottom"
              className="z-50 max-w-md whitespace-pre-wrap text-left"
            >
              {directiveDetails.description}
            </Tooltip>
          </>
        )}
      </div>
    </div>
  )
}

export default CreateForwardingDirectiveData
